import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/components/app.layout';
import { Dashboard } from './app/features/dashboard/dashboard';
import { Documentation } from './app/features/documentation/documentation';
import { Landing } from './app/features/landing/landing';
import { Notfound } from './app/features/notfound/notfound';
import { AuthGuard } from '@features/auth/guards/auth.guard';
import { PublicGuard } from '@features/auth/guards/public.guard';
import { PermissionGuard } from '@features/auth/guards/permission.guard';
import { PERMISSIONS } from './app/core/constants/permissions.constants';

export const appRoutes: Routes = [

    {
        path: 'auth', loadChildren: () => import('./app/features/auth/auth.routes')
    },
    {
        path: '',
        component: AppLayout,
        children: [

            { path: '', component: Dashboard },
            { path: 'uikit', loadChildren: () => import('./app/features/uikit/uikit.routes') },
            { path: 'documentation', component: Documentation },
            { path: 'pages', loadChildren: () => import('./app/features/pages.routes') },
            { path: 'reports', loadChildren: () => import('./app/features/reports/reports.routes'), },
            { path: 'admin', loadChildren: () => import('./app/features/admin/admin.routes') },
        ],
        canMatch: [AuthGuard],

    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },

    { path: '**', redirectTo: '/notfound' }
];
